var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PEC_lunBo2"},[_c('el-carousel',{ref:"carousel",attrs:{"autoplay":_vm.autoplay,"interval":4000,"height":this.height + 'em'}},_vm._l((_vm.imgsUrls),function(item){return _c('el-carousel-item',{key:item},[_c('img',{attrs:{"src":_vm.$hdAddress + item,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }